import {
	FileImageOutlined,
	VideoCameraOutlined,
	FilePdfOutlined,
} from "@ant-design/icons";
import { Alert, Form, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { api } from "services/api";
import { IAddBlocks } from "types";
import { formatUrl } from "utils";
import Swal from "sweetalert2";

const types = [
	{
		value: "",
		label: "Selecione o tipo",
	},
	{
		value: "text",
		label: "Textual",
	},
	{
		value: "image",
		label: "Imagem",
	},
	{
		value: "youtube",
		label: "Youtube",
	},
	{
		value: "vimeo",
		label: "Vimeo",
	},
	{
		value: "archive",
		label: "Arquivo",
	},
];

export const AddBlockContentModal: React.FC<IAddBlocks> = ({ ...props }) => {
	const [order, setOrder] = useState<number>(0);
	const [value, setValue] = useState<string>("");
	const [blockType, setBlockType] = useState<string>("text");
	const [error, setError] = useState<string>("");
	const {
		form,
		isOpen,
		setFiles,
		setIsOpen,
		files,
		currentClassInfo,
		setFromCreate,
		fromCreate,
		setProcessing,
		setBlocks,
	} = props;

	useEffect(() => {
		if (!isOpen) {
			setBlockType("");
		}
	}, [isOpen]);

	const handleSelectChange = (value: string) => {
		setBlockType(value);
	};

	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];

		if (file) {
			const reader = new FileReader();
			reader.readAsDataURL(file);

			reader.onload = () => {
				const base64 = reader.result?.toString();
				if (base64) {
					setFiles((prevState) => ({
						...prevState,
						[event.target.name]: base64 || "",
					}));
				}
			};
		}
	};

	const handleCreate = async (data: { [k: string]: string }) => {
		// if (blockType === "youtube" || blockType === "vimeo") {
		// 	if (!validateUrl(value)) {
		// 		setError("Informe uma url válida");
		// 		return;
		// 	}
		// }

		if (fromCreate) {
			setProcessing(true);
			setBlocks((prevState) => [
				...prevState,
				{
					order: order,
					type: blockType,
					content:
						blockType !== "text"
							? blockType !== "youtube"
								? blockType !== "vimeo"
									? files[blockType]
									: formatUrl(value)
								: formatUrl(value)
							: value,
				},
			]);
			setFromCreate(false);
			setBlockType("");
			setValue("");
			setOrder(0);
			// setError("");
			setFiles({ image: "", video: "", archive: "" });
			setProcessing(false);
		} else {
			const itUseValue = ["text", "youtube", "vimeo"];
			if (value.length === 0 && itUseValue.includes(blockType)) {
				setError("Informe o conteúdo do bloco");
				return;
			}

			const sendData = {
				class_id: currentClassInfo ? currentClassInfo.id : null,
				order: order,
				type: blockType,
				content:
					blockType !== "text"
						? blockType !== "youtube"
							? blockType !== "vimeo"
								? files[blockType]
								: formatUrl(value)
							: formatUrl(value)
						: value,
			};
			setProcessing(true);
			await api
				.post("/blocks", sendData)
				.then((res) => {
					const { id, type, order, content } = res.data.data.block;

					setBlocks((prevState) => [
						...prevState,
						{
							type: type,
							order: order,
							content: content,
							id: id,
						},
					]);
					setProcessing(false);
					handleReset();
					setIsOpen(!isOpen);
					setError("");
				})
				.catch((err) => {
					setProcessing(false);
					const status = err.response.status;
					const { feedback, message } = err.response?.data;
					if (
						status === 400 ||
						status === 401 ||
						status === 404 ||
						status === 403 ||
						status === 500
					) {
						Swal.fire({
							icon: "error",
							text: feedback["error"]
								? feedback["error"]
								: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
						});
						const html = document.getElementsByTagName("html");
						html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
						document.body.classList.remove("swal2-shown", "swal2-height-auto");
					}
					if (status === 422) {
						setError(message);
					}
				});
		}
	};

	const handleReset = () => {
		setValue("");
		setBlockType("");
		setOrder(0);
		setFiles({ image: "", video: "", archive: "" });
	};

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Adicionar bloco de conteúdo</p>}
			open={isOpen}
			maskClosable={false}
			okText="Adicionar bloco"
			cancelText="Cancelar"
			onOk={() => {
				handleCreate(form.getFieldsValue());
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				handleReset();
				setError("");
			}}
			zIndex={1001}
			width={700}
		>
			<Form form={form} name="new-course" autoComplete="off">
					<div className="row row-cols-1 row-cols-sm-2">
						<div className="mb-2">
							<label className="pb-1">Ordem</label>
							<Input
								id="order"
								type="number"
								min={1}
								minLength={1}
								value={order}
								onChange={(e) => {
									setOrder(Number(e.target.value));
								}}
							/>
						</div>
						<div>
							<label className="pb-1">Tipo de bloco</label>
							<Select
								placeholder="Tipo de bloco"
								value={blockType}
								className="m-modules-modal__select"
								onChange={handleSelectChange}
								options={types}
							/>
						</div>
					</div>

					{error && (
						<div className="m-modules-modal__error">
							<Alert
								message={error}
								type="error"
								showIcon
								closable
								onClose={() => setError("")}
							/>
						</div>
					)}

					<div
						className="m-modules-modal__textarea"
						style={{ marginTop: "15px" }}
					>
						{blockType === "text" && (
							<ReactQuill theme="snow" value={value} onChange={setValue} />
						)}
						{blockType === "image" && (
							<div
								className="m-classes-modal__login-info__avatar"
								style={{
									width: "80%",
									height: "100%",
									display: "flex",
									alignItems: "center",
									margin: "0 auto",
									justifyContent: "center",
								}}
							>
								{files.image ? (
									<img src={files.image} alt="" width="50%" height="100%" />
								) : (
									<FileImageOutlined />
								)}
								<label
									htmlFor="image"
									className="m-classes-modal__login-info__avatar__btn"
									style={{ width: "50%" }}
								>
									Enviar foto
								</label>
								<Input
									id="image"
									name="image"
									type="file"
									accept="image/*"
									style={{ display: "none" }}
									onChange={handleInputChange}
								/>
							</div>
						)}
						{blockType === "youtube" && (
							<div>
								<label className="pb-1">Url do Vídeo</label>
								{/* {error && <p style={{ color: "red", fontSize: 11 }}>{error}</p>} */}
								<Input
									id="youtube"
									type="text"
									value={value}
									onChange={(e) => {
										setValue(e.target.value);
									}}
								/>
							</div>
						)}
						{blockType === "vimeo" && (
							<div>
								<label>Url do Vídeo</label>
								{/* {error && <p style={{ color: "red", fontSize: 11 }}>{error}</p>} */}
								<Input
									id="vimeo"
									type="text"
									value={value}
									onChange={(e) => {
										setValue(e.target.value);
									}}
								/>
							</div>
						)}
						{blockType === "video" && (
							<div
								className="m-classes-modal__login-info__avatar"
								style={{
									width: "80%",
									height: "100%",
									display: "flex",
									alignItems: "center",
									margin: "0 auto",
									justifyContent: "center",
								}}
							>
								{files.video ? (
									<video width="100%" height="100%" controls>
										<source src={files.video} type="video/mp4" />
									</video>
								) : (
									<VideoCameraOutlined />
								)}
								<label
									htmlFor="video"
									className="m-classes-modal__login-info__avatar__btn"
									style={{ width: "50%" }}
								>
									Enviar vídeo
								</label>
								<Input
									id="video"
									type="file"
									accept="video/mp4,video/x-m4v,video/*"
									style={{ display: "none" }}
									onChange={(e) =>
										setFiles((prevState) => ({
											...prevState,
											// eslint-disalbe-next-line
											// @ts-ignore
											video: URL.createObjectURL(e.target.files?.[0]),
										}))
									}
								/>
							</div>
						)}
						{blockType === "archive" && (
							<div
								className="m-classes-modal__login-info__avatar"
								style={{
									width: "80%",
									height: "100%",
									display: "flex",
									alignItems: "center",
									margin: "0 auto",
									justifyContent: "center",
								}}
							>
								{files.archive ? (
									<a href={files.archive} target="_blank" rel="noreferrer">
										Ver arquivo
									</a>
								) : (
									<FilePdfOutlined />
								)}
								<label
									htmlFor="file"
									className="m-classes-modal__login-info__avatar__btn"
									style={{ width: "50%" }}
								>
									Enviar arquivo
								</label>
								<Input
									id="file"
									type="file"
									name="archive"
									accept=".pdf,.doc,.docx"
									style={{ display: "none" }}
									onChange={handleInputChange}
								/>
							</div>
						)}
					</div>
			</Form>
		</Modal>
	);
};
